import { useEffect, RefObject } from "react";

type IntersectionCallback = (isVisible: boolean) => void;

export const useIntersectionObserver = (
    ref: RefObject<HTMLDivElement>,
    callback: IntersectionCallback,
    options: IntersectionObserverInit = {}
) => {
    useEffect(() => {
        if (!ref.current) return;

        const observer = new IntersectionObserver(
            (entries) => {
                callback(entries[0].isIntersecting);
            },
            options
        );

        observer.observe(ref.current);

        return () => {
            if (ref.current) observer.unobserve(ref.current);
        };
    }, [ref, callback, options]);
};
